// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__(2536);



// WEBPACK FOOTER //
// webpack://pdfmake/webpack/startup